import * as React from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { Box, Toolbar, useTheme } from '@mui/material'
import ListaMenu from '../components/shared/lists/SidebarList'
import PainelAppbar from '../components/shared/appbar'
import MobileDrawer from '../components/shared/drawers/MobileDrawer'
import DesktopDrawer from '../components/shared/drawers/DesktopDrawer'
import SidebarIcon from '../components/shared/SidebarIcon'
import { useKeycloak } from '@react-keycloak/web'
import { useContext, useEffect, useState } from 'react'
import { PermissionsContext } from '../providers/permissions'

const drawerWidth = 240
const sectionSize = '96%'
function BaseLayout(props) {
  const { keycloak } = useKeycloak()
  const isLogged = keycloak.authenticated || false
  const { permissions } = useContext(PermissionsContext)
  const { window } = props
  const [mobileOpen, setMobileOpen] = React.useState(false)
  const theme = useTheme()

  const location = useLocation()

  useEffect(() => {
    if (location.pathname !== '/leitura/leituras') {
      localStorage.removeItem('filterGestao', '{}')
    }
  }, [location.pathname])

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const bibliotecarioMenu = [
    { name: 'Dashboard', path: '', roles: 'leitor' },
    { name: 'Livros', path: '/livros', roles: 'leitor' },
    { name: 'Empréstimo', path: '/emprestimo', roles: 'leitor' },

    { name: 'Sugestão', path: '/sugestao', roles: 'gestor' },
    {
      name: 'Auto Empréstimo',
      path: '/autoemprestimo',
      roles: 'gestor'
    },
    {
      name: 'QR Code',
      path: '/qrcode',
      roles: 'gestor'
    },
    { name: 'Leituras', path: '/leituras', roles: 'leitor' },
    {
      name: 'Postar Resumo',
      path: '/leituras/cadastro/',
      roles: 'none',
      secondary: true
    },
    { name: 'Reservas', path: '/reservas', roles: 'gestor' },
    { name: 'Exemplar', path: '/livro/', roles: 'none', secondary: true },
    { name: 'Gestores', path: '/gestor', roles: 'gestor' },
    { name: 'Bibliotecários', path: '/bibliotecario', roles: 'gestor' },
    { name: 'Leitores', path: '/leitor', roles: 'bibliotecario' },
    { name: 'Relatórios', path: '/relatorio', roles: 'bibliotecario' },
    { name: 'Logs', path: '/logs', roles: 'gestor' }
  ]

  // const leitorMenu = [
  //   { name: 'Dashboard', path: '', roles: 'leitor' },
  //   { name: 'Livros', path: '/livros', roles: 'leitor' },
  //   { name: 'Leituras', path: '/leituras', roles: 'leitor' },
  //   { name: 'Reservas', path: '/reservas', roles: 'gestor' },
  //   { name: 'Sugestão', path: '/sugestao', roles: 'gestor' },
  //   {
  //     name: 'Postar Resumo',
  //     path: '/leituras/cadastro/',
  //     roles: 'none',
  //     secondary: true
  //   },
  //   { name: 'Exemplar', path: '/livro/', roles: 'none', secondary: true },
  //   { name: 'Relatórios', path: '/relatorio', roles: 'bibliotecario' }
  // ]

  const [menus, setMenus] = useState([])
  useEffect(() => {
    if (permissions !== null) {
      // const array = permissions.roles.includes('bibliotecario')
      //   ? bibliotecarioMenu
      //   : leitorMenu
      const array = bibliotecarioMenu
      const aux = array.map(item => ({
        ...item,
        path: `${process.env.PUBLIC_URL}${item.path}`
      }))
      setMenus(aux)
    }
  }, [permissions])

  const drawer = (
    <div>
      {isLogged && <SidebarIcon />}
      {isLogged && <ListaMenu menus={menus} />}
    </div>
  )

  const container =
    window !== undefined ? () => window().document.body : undefined

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        background: theme.palette.background.main
      }}
    >
      {isLogged && (
        <PainelAppbar
          sectionSize={sectionSize}
          drawerWidth={drawerWidth}
          actionToggle={handleDrawerToggle}
          routes={menus}
        />
      )}

      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <MobileDrawer
          actionToggle={handleDrawerToggle}
          mobileOpen={mobileOpen}
          container={container}
          drawerWidth={drawerWidth}
        >
          {drawer}
        </MobileDrawer>
        <DesktopDrawer drawerWidth={drawerWidth}>{drawer}</DesktopDrawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` }
        }}
      >
        <Box sx={{ width: { sm: sectionSize }, margin: { sm: '0 auto' } }}>
          <Toolbar />
          {props.children}
        </Box>
      </Box>
    </Box>
  )
}

BaseLayout.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
  children: PropTypes.element
}

export default BaseLayout
